import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { AppMaterialModule } from 'src/app/app-material.module';
import { ContractNumberSearchModel } from 'src/app/models/ContractNumberSearchModel';

import {
  VccRequestSearchModalComponent,
  VccSearchModel,
} from './vcc-request-search-modal/vcc-request-search-modal.component';
import { ContractRequestSearchModalComponent } from './contract-request-search-modal/contract-request-search-modal.component';

export enum IncumbentDropdownOptions {
  CONTRACT_NUMBER = 'Contract Number',
  VCC = 'Vizient Contract Category',
}

export type IncumbentCriteriaValue =
  | ContractNumberSearchModel
  | VccSearchModel
  | null;

export interface IncumbentCriteriaResult {
  resultType: IncumbentDropdownOptions;
  value: IncumbentCriteriaValue;
}
export function isValidResult(result?: IncumbentCriteriaResult) {
  return result !== null && result.resultType !== null && result.value != null;
}

@Component({
  selector: 'app-request-target-search',
  templateUrl: './request-target-search.component.html',
  standalone: true,
  imports: [
    CommonModule,
    AppMaterialModule,
    MatOptionModule,
    ReactiveFormsModule,
    ContractRequestSearchModalComponent,
    VccRequestSearchModalComponent,
  ],
  styleUrls: ['./request-target-search.component.scss'],
})
export class RequestTargetSearchComponent implements OnInit {
  protected readonly IncumbentDropdownOptionsEnum = IncumbentDropdownOptions;
  @Input() public dropdownOptions: IncumbentDropdownOptions[] = Object.values(
    IncumbentDropdownOptions,
  );

  @Output() public incumbentSelected =
    new EventEmitter<IncumbentCriteriaResult | null>();

  dropdownFormControl = new FormControl<IncumbentDropdownOptions>(
    IncumbentDropdownOptions.CONTRACT_NUMBER,
  );

  ngOnInit() {
    this.dropdownFormControl.valueChanges.subscribe((_: any) => {
      this.incumbentSelected.next(null);
    });
  }

  onSelectionChange(
    selection: ContractNumberSearchModel | VccSearchModel | null,
  ) {
    const resultType = this.dropdownFormControl.value;
    if (!resultType) {
      return;
    }

    this.incumbentSelected.next({
      resultType,
      value: selection,
    } satisfies IncumbentCriteriaResult);
  }
}
